import { ROUTES } from "../../../routes";
import { MdSearch } from "react-icons/md";
import usePageTitle from "../../../hooks/use-page-title";
import ApiProgramme from "../../../modules/api/programme";
import { Link } from "react-router-dom";
import AppUserContext from "../../../context/app-user-context";
import { useState, useContext, useEffect } from "react";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import ServerSideProgrammeDataTable from "../../../components/common/ServerSideProgrammeDataTable";


export default function PageExportReportList() {
  const title = "Export Reports";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);
  const user = useContext(AppUserContext);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setCustomText(title);
  } , []);

  return (
    <main className="form-generic content-generic content-generic--fluid">
      {/* <h1 className="fs-title hide-mobile-down">{title}</h1> */}

      <div className="cg__actions">
        <div className="cg__action-buttons d-none">
          <button
            className="btn btn-outline-dark"
            onClick={() => setRefresh((i) => !i)}
          >
            Refresh
          </button>
        </div>
        <div className="cg__action-search">
          <span>
            <MdSearch />
          </span>
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <p style={{ fontSize: "16px" }}>Please select a Programme to choose Reports you want to export.</p>

      <ServerSideProgrammeDataTable
        api={ApiProgramme.pagingSearch}
        search={search}
        columns={[
          {
            id: "name",
            name: "Name of Programme",
            sortable: true,
            maxWidth: "250px",
            selector: (row) => row.name,
            // cell: (row) => (
            //   <Link
            //   to={`${ROUTES.PORTAL_EXPORT_REPORTS}/select-cohort/${row._id}`}
            //   className="title-column"
            //   state={{ from: ROUTES.PORTAL_EXPORT_REPORTS }}
            //   >
            //     {row.name}
            //   </Link>
            // ),
          },
          {
            id: "description",
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
            cell: (row) => (
              <div className="description-column">{row.description}</div>
            ),
          },
          {
            id: "action",
            maxWidth: "100px",
            name: "",
            cell: (row) => {
              const from = ROUTES.PORTAL_EXPORT_REPORTS;
              return (
                <div className="manage-cohorts-link-wrapper">
                  <Link
                    to={`${ROUTES.PORTAL_EXPORT_REPORTS}/select-cohort/${row._id}`}
                    className="manage-cohorts-link"
                    state={{ from: from }}
                  >
                    Select
                  </Link>
                </div>
              );
            },
          },
        ]}
        refresh={refresh}
        programAdminId={user.referenceUserId}
      />
    </main>
  );
}
